import React from "react";
import {Link, useNavigate} from "react-router-dom";
import styles from "./SubMenu.module.scss";
import arrowDownIcon from "@/assets/icons/arrowHeaderDown.svg";

import { SubMenuItemsType, SubMenuPropsType } from "../../types";

const subMenuItemsServices: SubMenuItemsType = [
  { id: "services", name: "Аренда ракеток", href: "/services/racket-calendar" },
  { id: "products", name: "Товары", href: "/services/products" },
  { id: "tennis-school", name: "Школа тенниса", href: "/services/tennis-school" },
  { id: "personal-trainings", name: "Персональные тренировки", href: "/services/personal-trainings" },
];

const subMenuItemsAbout: SubMenuItemsType = [
  { id: "foto", name: "Галерея", href: "/about/photo" },
  { id: "locationMap", name: "Схема проезда", href: "/about/direction" },
  { id: "schemeCourts", name: "Схема кортов", href: "/about/court-layout" },
  { id: "news", name: "Новости", href: "/about/news" },
  { id: "feedback", name: "Обратная связь", href: "/feedback" },
];

const subMenuItemsPadel: SubMenuItemsType = [
  { id: "games", name: "Игры", href: "/padel/games/available" },
  { id: "tournaments", name: "Турниры", href: "/padel/tournaments/available" },
];

const SubMenu: React.FC<SubMenuPropsType> = (props: SubMenuPropsType) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);
  const subMenuRef = React.useRef<HTMLUListElement>(null);
  const subMenuTriggerRef = React.useRef<HTMLAnchorElement>(null);
  const subMenuLinksRef = React.useRef<HTMLAnchorElement[] | null[]>([]);
  const navigate = useNavigate();
  const handleNavigation = (href: string) => {
    navigate(href);
    setIsSubMenuOpen(false);
  };

  React.useEffect(() => {
    document.body.addEventListener("click", handleClickOutside);

    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const { href, name, type } = props;
  
  let subMenuItems: SubMenuItemsType;
  if (type === "services") {
    subMenuItems = subMenuItemsServices;
  } else if (type === "padel") {
    subMenuItems = subMenuItemsPadel;
  } else {
    subMenuItems = subMenuItemsAbout;
  }
  
  const subMenu = renderSubMenu(subMenuItems);

  const handleSubMenuClick = () => {
    setIsSubMenuOpen((isSubMenuOpen) => !isSubMenuOpen);
  };

  const handleClickOutside = (e: MouseEvent) => {
    const isLinkRefArray = subMenuLinksRef.current.map((item) =>
        item ? e.composedPath().includes(item) : null
    );
    if (isLinkRefArray.includes(true)) {
      setIsSubMenuOpen(false);
    } else if (
        subMenuRef.current &&
        !e.composedPath().includes(subMenuRef.current) &&
        subMenuTriggerRef.current &&
        !e.composedPath().includes(subMenuTriggerRef.current)
    ) {
      setIsSubMenuOpen(false);
    }
  };

  function renderSubMenu(menuItems: SubMenuItemsType) {
    return menuItems.map(({ id, name, href }) => (
        <li key={id}>
          <Link to={href} onClick={() => setIsSubMenuOpen(false)}>{name}</Link>
        </li>
    ));
  }

  return (
    <>
      <a
        className={styles.mainMenu__link__sub + (isSubMenuOpen ? ` ${styles.active}` : "")}
        onClick={handleSubMenuClick}
        ref={subMenuTriggerRef}
      >
        {name}
        <img src={arrowDownIcon} alt="arrow down" />
      </a>
      <ul
        className={
          styles.subMenu__about + (isSubMenuOpen ? ` ${styles.active}` : "")
        }
        ref={subMenuRef}
      >
        {subMenu}
      </ul>
    </>
  );
};

export default SubMenu;
